import { Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { ModalContainerComponent } from '../components/_common/modal-container/modal-container.component'
import { ProductMove } from 'depoto-core/src/entities'
import { SchemaUtil } from '../utils'
import { CoreService } from '../services'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-modal-serial-numbers',
  templateUrl: './modal-serial-numbers.component.html',
  styleUrls: ['./modal-serial-numbers.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalSerialNumbersComponent {
  @ViewChild('modal') public modal: ModalContainerComponent
  @Input() productMove: ProductMove
  @Input() isCreatingProductMovePack: boolean
  @Input() hideOpenButton: boolean = false
  loading = true
  serialNumbersInString: string = ''
  alreadyExistingSerialNumbers: string[] = []
  @Output() serialNumbersEdited: EventEmitter<string[]> = new EventEmitter<string[]>()
  @Output() serialNumbersChanged: EventEmitter<string[]> = new EventEmitter<string[]>()

  constructor(
    private core: CoreService,
    private translateService: TranslateService
  ) {}

  public showChildModal(productMove: ProductMove = this.productMove): void {
    this.loading = true
    this.productMove = productMove
    this.serialNumbersInString = ''
    this.alreadyExistingSerialNumbers = []
    this.loading = false
    this.modal.showChildModal()
  }

  public hideChildModal(): void {
    this.modal.hideChildModal()
  }

  async setSerialNumbers() {
    const actual = this.productMove.serialNumbers?.length ?? 0
    const required = Number(this.productMove.amount)
    if (actual !== required) {
      alert(
        this.translateService.instant('modal-serial-number.wrong.amount.of.pieces', {
          actual,
          required: this.productMove.amount,
        })
      )
      return
    }
    this.loading = true
    if (!this.isCreatingProductMovePack) {
      try {
        const result = await this.core.services.productMove.update(this.productMove, SchemaUtil.productMove)
        //todo
      } catch (err) {
        console.error(err)
      }
    } else {
      this.serialNumbersEdited.emit(this.productMove.serialNumbers)
    }
    this.hideChildModal()
    this.loading = false
  }

  addSerialNumbers() {
    const currentSerialNumbers = this.productMove.serialNumbers ?? []
    const serialNumbersToAdd = this.serialNumbersInString
      .split('\n')
      .filter(serialNumber => serialNumber.length > 0)
      .filter((serialNumber, index, serialNumbers) => serialNumbers.indexOf(serialNumber) === index)
      .filter(serialNumber => !currentSerialNumbers.includes(serialNumber))
    const required = Number(this.productMove.amount)

    if (currentSerialNumbers.length + serialNumbersToAdd.length > required) {
      alert(
        this.translateService.instant('modal-serial-number.maximum.amount.of.pieces', {
          required: this.productMove.amount,
        })
      )
      return
    }

    if (serialNumbersToAdd.length) {
      this.productMove.serialNumbers = [...currentSerialNumbers, ...serialNumbersToAdd]
      this.serialNumbersChanged.emit([...this.productMove.serialNumbers])
    }
    this.serialNumbersInString = ''
  }

  keyPressed(event) {
    console.log(event)
  }

  removeSerialNumber(selectedSerialNumber) {
    const serialNumbers = this.productMove.serialNumbers.filter(serialNumber => serialNumber !== selectedSerialNumber)
    if (serialNumbers.length === this.productMove.serialNumbers.length) return

    this.productMove.serialNumbers = serialNumbers
    this.serialNumbersChanged.emit([...this.productMove.serialNumbers])
  }
}
